import { render } from "./App.vue?vue&type=template&id=f4f1213e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f4f1213e&lang=scss"
script.render = render

export default script